export const isMatchingDomain = (domains) => {
  const currentUrl = window.location.href;
  return domains.some((domain) => currentUrl.includes(domain));
};

// Usage example:
// Import the function where needed
// import { isMatchingDomain } from "../../utils/urlUtils";

// Example usage:
export const domains = [
  "lighthouseadmin.ltm.com",
  "lighthouseadmin.ltimindtree.com",
];
